import { arrayAny } from "../../utils/arrayUtils";

export const ContactSelector = ({ contacts, selectedContact, onContactSelect, defaultContact }) => {

    const firstContact = defaultContact ? defaultContact :
         arrayAny(contacts) ? contacts[0] : null;

    return arrayAny(contacts) && firstContact ? (

        <div className="mb-3 d-md-flex fw-bold">
            <div className="dropdown-toggle">
                <div style={{ cursor: "pointer" }}
                    data-bs-toggle="dropdown"
                    className="text-decoration-none text-dark">
                    <i className="far fa-user fa-fw text-dark text-opacity-50 me-1" />
                    {(selectedContact ?? firstContact).contactName}
                    <b className="ms-5px caret ms-auto"></b>
                </div>

                <div className="dropdown-menu dropdown-menu-start">
                    {contacts.map(contact => ( // For each landlord...
                        <div
                            onClick={() => onContactSelect(contact)} style={{ cursor: "pointer" }}
                            key={contact.id}
                            className="dropdown-item">
                            <i className="far fa-user fa-fw fa-lg text-gray-500 me-1" />{contact.contactName}
                        </div>

                    ))}
                </div>
            </div>
        </div>
    )
        :
        (<>Loading...</>);
};